import styled from "styled-components";
import {CssRule} from "../../../themes/architecture/css-helpers/css-rule";
import {DRAGGING, OPEN_MENU} from "../../../themes/css-global-classes";

export interface MainNavBoxProps {
    zIndex: number;
}

export const MainNavBox = styled.div<MainNavBoxProps>`
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
  margin: 0 auto 0 0;
  transition: transform 0.2s ease-in-out;
  z-index: ${props => props.zIndex};
  min-width: 23rem;

  @media ${({theme}) => theme.mediaQuery.lAndBelow } {
    height: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    transform: translateX(-100%);
    ${CssRule.For.RTL.build()} & {
      transform: translateX(100%);
    }

    &.${OPEN_MENU} {
      transform: translateX(0);
      /* We need to duplicate din rule for selector specificity */
      ${CssRule.For.RTL.build()} & {
        transform: translateX(0);
      }
      overflow: hidden;


      @media ${({theme}) => theme.mediaQuery.landscape} {
        padding-left: env(safe-area-inset-left);
        padding-right: env(safe-area-inset-right);
      }
    }


    &.${DRAGGING} {
      transition: none;
    }


    /*
      .cgp-landscape.cgp-ios & {
    &.open-menu {
      padding-left: env(safe-area-inset-left);
    }
  }

  .cgp-landscape.cgp-ios.cgp-rtl & {
    &.open-menu {
      padding-right: env(safe-area-inset-right);
    }
  }
     */
}
`